/**
 * Strip a US phone number to bare 10 digits (drops +1 / a leading country-code
 * 1). Mirrors the backend's `did._normalize_phone` so the operator sees, and
 * submits, the same shape the Do-Not-Call scrub actually matches on. Returns ""
 * for input with no usable digits, which the caller should reject.
 */
export function normalizePhone(raw: string): string {
  const d = raw.replace(/\D/g, "");
  return d.length === 11 && d.startsWith("1") ? d.slice(1) : d;
}
